// https://stackoverflow.com/questions/4825683/how-do-i-create-and-read-a-value-from-cookie/48706852#48706852
export const Cookie = {
  get: (name) => {
    let c = document.cookie.match(
      `(?:(?:^|.*; *)${name} *= *([^;]*).*$)|^.*$`
    )[1];
    if (c) return decodeURIComponent(c);
  },
  set: (name, value, opts = {}) => {
    /*If options contains days then we're configuring max-age*/
    if (opts.days) {
      opts['max-age'] = opts.days * 60 * 60 * 24;

      /*Deleting days from options to pass remaining opts to cookie settings*/
      delete opts.days;
    }

    /*Configuring options to cookie standard by reducing each property*/
    opts = Object.entries(opts).reduce(
      (accumulatedStr, [k, v]) => `${accumulatedStr}; ${k}=${v}`,
      ''
    );

    /*Finally, creating the key*/
    document.cookie = name + '=' + encodeURIComponent(value) + opts;
  },
  delete: (name, opts) => Cookie.set(name, '', { 'max-age': -1, ...opts }),
  // path & domain must match cookie being deleted
};

export const fetchUtmSettings = (params) => {
  let rCampaign = params.get('r_campaign') || params.get('utm_campaign');
  if (!rCampaign) {
    rCampaign = Cookie.get('cv_r_campaign');
  } else {
    Cookie.set('cv_r_campaign', rCampaign, { days: 1 });
  }

  let rMedium = params.get('r_medium') || params.get('utm_medium');
  if (!rMedium) {
    rMedium = Cookie.get('cv_r_medium');
  } else {
    Cookie.set('cv_r_medium', rMedium, { days: 1 });
  }

  let rSource = params.get('r_source') || params.get('utm_source');
  if (!rSource) {
    rSource = Cookie.get('cv_r_source');
  } else {
    Cookie.set('cv_r_source', rSource, { days: 1 });
  }

  let rTerm = params.get('r_term') || params.get('utm_term');
  if (!rTerm) {
    rTerm = Cookie.get('cv_r_term');
  } else {
    Cookie.set('cv_r_term', rTerm, { days: 1 });
  }

  let rContent = params.get('r_content') || params.get('utm_content');
  if (!rContent) {
    rContent = Cookie.get('cv_r_content');
  } else {
    Cookie.set('cv_r_content', rContent, { days: 1 });
  }

  return {
    rCampaign,
    rMedium,
    rSource,
    rTerm,
    rContent,
  };
};

export const pushFormSubmissionDataLayer = (dataLayerEventId: string, values) => {
  window.dataLayer = window.dataLayer || [];
  
  const newValues = {};

  if (values && values.mobile_no) {
    if (!values.mobile_no.startsWith("+")){
      newValues.mobile_no = `+65${values.mobile_no}`;
    }
  }

  const data = {
    event: `formsubmission_${dataLayerEventId}`,
    ...values,
    ...newValues,
  }

  window.dataLayer.push(data);
};
